import styles from "./EmitModalButton.module.scss"

type Props = {
	text: string
	onClick: () => void
	hide: boolean
	// "blue" は souhl_admin 限定操作など、通常操作と見た目で区別したいボタン向け
	variant?: "default" | "blue"
}

const EmitModalButton = ({
	text,
	onClick,
	hide,
	variant = "default",
}: Props) => {
	return (
		<button
			className={`${styles.emit_modal_button} ${
				variant === "blue" ? styles.blue : ""
			}`}
			onClick={onClick}
			style={{ visibility: hide ? "hidden" : "visible" }}
		>
			{text}
		</button>
	)
}

export default EmitModalButton
